<template>
<button :class="classname"  :id="id"  @click="handleClick">
<mcc-icon v-if="icon" :name="icon" aria-hidden="true"></mcc-icon><span class="mcc-button__label">{{label}}</span></button>
</template>

<script>
export default {
    props: ['icon', 'label', 'to','id','classname'],
    methods: {
        handleClick() {
            this.$router.push(this.to).catch(err => {})
        }
    }
}
</script>
